import React, { useState } from 'react';

export default function CreateTicketModal({ isOpen, onClose, onCreated, apiBase='/api/tickets_advanced_jwt.php', token }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState('normal');
  const [service, setService] = useState('');
  const [busy, setBusy] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [requesterEmail, setRequesterEmail] = useState('');

  if (!isOpen) return null;

  async function submit(e) {
    e.preventDefault();
    if (!title.trim()) return alert('Título é obrigatório');
    // if no token, require requester email
    if (!token && !requesterEmail.trim()) return alert('Email do solicitante é obrigatório se não estiver autenticado');
    setBusy(true);
    try {
      const payload = {
        title: title.trim(),
        description: description.trim(),
        priority,
        service,
        requester_email: token ? null : requesterEmail.trim()
      };
      const res = await fetch(apiBase, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': 'Bearer ' + token } : {})
        },
        body: JSON.stringify(payload)
      });

      // safely read response: handle empty body
      const text = await res.text();
      let j = null;
      if (text && text.trim() !== '') {
        try { j = JSON.parse(text); } catch (err) { console.error('Invalid JSON response', text); }
      }

      if (!res.ok) {
        const msg = j && (j.error || (j.errors ? j.errors.join('; ') : null)) ? (j.error || (Array.isArray(j.errors) ? j.errors.join('; ') : JSON.stringify(j.errors))) : ('HTTP ' + res.status);
        throw new Error(msg);
      }

      // success: either j.ticket or j
      const ticket = j?.ticket ?? j;
      onCreated && onCreated(ticket);
      // reset form
      setTitle(''); setDescription(''); setPriority('normal'); setService(''); setAttachment(null); setRequesterEmail('');
      onClose();
    } catch (err) {
      console.error(err);
      alert('Falha ao criar ticket: ' + (err.message || err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded w-11/12 md:w-1/2 p-4 max-h-[90vh] overflow-auto">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold">Novo Ticket</h3>
          <button onClick={onClose} className="px-2 py-1 border rounded">Fechar</button>
        </div>
        <form onSubmit={submit}>
          <div className="mb-2">
            <label className="block text-sm font-medium">Título</label>
            <input className="w-full p-2 border rounded" value={title} onChange={e=>setTitle(e.target.value)} required />
          </div>
          <div className="mb-2">
            <label className="block text-sm font-medium">Descrição</label>
            <textarea className="w-full p-2 border rounded" rows={6} value={description} onChange={e=>setDescription(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-2 mb-2">
            <div>
              <label className="block text-sm font-medium">Prioridade</label>
              <select className="w-full p-2 border rounded" value={priority} onChange={e=>setPriority(e.target.value)}>
                <option value="low">Baixa</option>
                <option value="normal">Normal</option>
                <option value="high">Alta</option>
                <option value="urgent">Urgente</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Serviço</label>
              <input className="w-full p-2 border rounded" value={service} onChange={e=>setService(e.target.value)} placeholder="ex: rede, salas, limpezas" />
            </div>
          </div>
          {!token && (
            <div className="mb-2">
              <label className="block text-sm font-medium">Email do solicitante</label>
              <input className="w-full p-2 border rounded" value={requesterEmail} onChange={e=>setRequesterEmail(e.target.value)} placeholder="nome@exemplo.pt" />
            </div>
          )}
          <div className="mb-3">
            <label className="block text-sm font-medium">Anexo (não processado no backend dev)</label>
            <input type="file" onChange={e=>setAttachment(e.target.files[0] || null)} />
            <div className="text-xs text-gray-500">Nota: uploads ainda não estão implementados no backend. O ficheiro não será guardado.</div>
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="px-3 py-1 rounded border">Cancelar</button>
            <button type="submit" disabled={busy} className="px-3 py-1 rounded bg-slate-800 text-white">{busy ? 'A criar...' : 'Criar Ticket'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
